import { defineMessages } from 'react-intl';

type MessageKeys = 'templatesCategory' | 'templatesSubtitle';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description: string }
> = defineMessages({
	templatesCategory: {
		id: 'studio-browse-kit.browse-agent.entrypoints.templates.templatesCategory',
		defaultMessage: 'Templates',
		description:
			'Label and heading for the Browse agents category containing all available agent templates.',
	},
	templatesSubtitle: {
		id: 'studio-browse-kit.browse-agent.entrypoints.templates.templatesSubtitle',
		defaultMessage: 'Start from an agent template',
		description:
			'Description of the full list of agent templates that users can preview and remix.',
	},
});
